import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const ConfirmDialog = ({ open, onClose, onConfirm, title, content }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
              <Button onClick={onClose} color="primary blue-button">Cancel</Button>
              <Button onClick={onConfirm} color="secondary blue-button">Confirm</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
